import { useState, useEffect, useContext } from 'react';

// アクセス集中
function PracticeReserveAccessAlert() {

  return (
    <div className="alert alert-danger">
      <small>
        大変申し訳ございませんが現在セッション可能な日程は全て埋まってしまいました。<br />
        セッション可能な日程は現在も拡張させて頂いており、随時予約可能な枠が表示されていきますので、しばらく時間を置いた後再度こちらの画面にアクセスして頂き、セッション可能日程状況のご確認をお願い致します。<br />
        ご不便をおかけ致しまして大変申し訳ございませんが、ご了承下さいますよう宜しくお願い致します。<br />
      </small>
    </div>
  );
}
  
export default PracticeReserveAccessAlert;